import * as S from "./Loading.style";

export const Loading = ({ width = 60, height = 60 }: any) => {
  return (
    <S.Loading>
      <S.LoadingCircle $width={width} $height={height} />
      <S.LoadingTxt>불러오는 중...</S.LoadingTxt>
    </S.Loading>
  );
};
